import api from './api';

export interface UserHistoryRow {
  recno: number;
  dbtable: string;
  keyvalue: string;
  datetime: string;
  userid: string;
  colname: string;
  oldval: string;
  newval: string;
  type: string;
  otherid: string;
}

export interface UserHistoryResponse {
  days: number;
  userids: string[];
  items: UserHistoryRow[];
}

const userHistoryService = {
  getMyHistory: async (signal?: AbortSignal): Promise<UserHistoryResponse> => {
    const res = await api.get<UserHistoryResponse>('/users/me/history', { signal });
    return res.data;
  },
  /** Admin (Developer group) — any user's history by Azure AD oid. */
  getUserHistory: async (userId: string, signal?: AbortSignal): Promise<UserHistoryResponse> => {
    const res = await api.get<UserHistoryResponse>(`/users/${userId}/history`, { signal });
    return res.data;
  },
};

export default userHistoryService;
